import React, { useMemo } from "react";

import { format } from "date-fns";

import {
  RelationshipNoteId,
  RelationshipNoteListItemType,
} from "@fartherfinance/frontend/api/Notes/types";

import {
  Column,
  Row,
  SophisticatedCell,
} from "@src/sharedComponents/Table/Types";
import Text from "@src/sharedComponents/Typography/Text";

import styles from "./ClientNotes.module.css";

export type NotesTableColumns = "Date" | "Note" | "Author";
export const NotesTableColumns: NonEmptyArray<NotesTableColumns> = [
  "Date",
  "Note",
  "Author",
];

export const useNotesColumns = ({
  sortOrder,
  sortable,
}: {
  sortOrder: "asc" | "desc";
  sortable: boolean;
}) => {
  return useMemo(() => {
    const columns: Column<NotesTableColumns>[] = [
      {
        label: "Date",
        accessor: "Date",
        sortable: true,
        active: sortable,
        sortOrder,
      },
      {
        label: "Note",
        accessor: "Note",
        sortable: false,
      },
      {
        label: "Author",
        accessor: "Author",
        sortable: false,
      },
    ];

    return columns;
  }, [sortOrder, sortable]);
};

export const useNotesRows = (
  notes: RelationshipNoteListItemType[],
  handleNoteClick: (id: RelationshipNoteId) => void
) => {
  return useMemo(() => {
    const tableRows: Row<NotesTableColumns, SophisticatedCell | string>[] =
      notes.map((note) => ({
        key: note.noteId,
        Date: format(new Date(note.createdAt), "P"),
        Note: {
          value: (
            <Text variant="body" color="text" className={styles.noteContent}>
              {note.title}
            </Text>
          ),
          fullValue: note.title,
        },
        Author: {
          value: (
            <Text variant="body" color="textSubtle">
              {note.createdByName}
            </Text>
          ),
          fullValue: note.createdByName,
        },
        onClick: () => handleNoteClick(note.noteId),
      }));

    return tableRows;
  }, [handleNoteClick, notes]);
};
